
export default {
  getRequirementSpecifications: state => {
    return state.requirementSpecifications
  }
}
